import { Flex, Small, FlexItem, P } from "orcs-design-system";
import PropTypes from "prop-types";

import {
  getReportingLineNames,
  truncateReportingLine,
} from "src/util/reportingLineBreadcrumb";

const PersonFormatOptionLabel = ({ label, person, useSupplyChain = false }) => {
  const managers = truncateReportingLine(
    getReportingLineNames(person, useSupplyChain)
  );

  return (
    <Flex key={label}>
      <FlexItem minWidth={0}>
        <P color="bodyText">{label}</P>
        {person?.jobTitle && (
          <Small display="block" color="mutedText">
            {person.jobTitle}
          </Small>
        )}
        {/* One item per manager so the line wraps even where the parent is
            nowrap (react-select's selected value); the direct manager is last. */}
        {managers.length > 0 && (
          <Flex flexWrap="wrap" gap="xs">
            {managers.map((name, index) => (
              <Small key={`${index}-${name}`} color="mutedText">
                {index > 0 ? `› ${name}` : name}
              </Small>
            ))}
          </Flex>
        )}
      </FlexItem>
    </Flex>
  );
};

PersonFormatOptionLabel.propTypes = {
  label: PropTypes.string,
  person: PropTypes.object,
  useSupplyChain: PropTypes.bool,
};

export default PersonFormatOptionLabel;
